import { render, staticRenderFns } from "./ModalFormComponent.vue?vue&type=template&id=5227c0dc&scoped=true"
import script from "./ModalFormComponent.vue?vue&type=script&lang=js"
export * from "./ModalFormComponent.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalFormComponent.vue?vue&type=style&index=1&id=5227c0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5227c0dc",
  null
  
)

export default component.exports